import { createContext } from 'react';

import { OpsHuddleDashboardResponse } from '@totem/components/ticketing/opsTeamHuddle/types';

interface Context {
  loading: boolean;
  data: OpsHuddleDashboardResponse | null;
  onRefresh: () => void;
}

const defaultValue: Context = {
  loading: true,
  data: null,
  onRefresh: () => {},
};

const OpsTeamHuddleContext = createContext<Context>(defaultValue);

export default OpsTeamHuddleContext;
